export default function currencyToNumber(money = null) {
  if (money === null) {
    return null;
  }

  if (typeof money !== 'string') {
    return money;
  }

  return parseFloat(money.replace(/\./, '').replace(/\,/, '.'));
}
